<template>
  <div class="font-roboto">
    <Breadcrumbs :title="$t('lbl_EMPBE_OpenSearch')" />
    <div class="wrapper">
      <div class="mb-0 f-24 w-100">
        <div v-if="isUatEnv" class="h1 text-danger m-b-20">
          {{ localeMap.uatWarning }}
        </div>

        <div class="h4 d-flex">
          <span>
            {{ localeMap.pageDesc }}
          </span>
          <i
            class="fa fa-info-circle f-16 m-l-5"
            @click="isLocationInfoOpened = true"
            style="cursor: pointer"
          />
        </div>

        <p
          v-for="(msg, index) in reminderMessages"
          :key="index"
          class="lead"
          style="font-size: 1rem; margin: 0"
        >
          <strong> - {{ msg }} </strong>
        </p>

        <!-- <div>
          <span class="reminder-text"> {{ localeMap.funcReminder }} </span>
        </div> -->
      </div>

      <OSWordSplitGrid ref="OSWordSplitGrid" />
    </div>

    <div>
      <div
        class="b-sidebar-backdrop bg-dark"
        style="z-index: 100"
        v-if="isLocationInfoOpened"
        @click="isLocationInfoOpened = false"
      ></div>

      <b-sidebar
        id="locationInfoSideBarPopup"
        right
        bg-variant="white"
        :shadow="true"
        v-model="isLocationInfoOpened"
        ref="locationInfoSideBarPopup"
        no-header
      >
        <div class="h-100">
          <div
            class="sticky-top p-20 f-24 font-weight-bold border-bottom d-flex justify-content-between align-items-center bg-white"
          >
            <span>
              {{ $t("lbl_EMPBE_OpenSearch") }}
            </span>

            <button
              class="close-sidebar-btn"
              type="button"
              @click="isLocationInfoOpened = false"
            >
              <i class="icon-close f-14" />
            </button>
          </div>
          <div class="p-20 w-100">
            <img class="w-100" :src="localeMap.imageSrc" />
          </div>
        </div>
      </b-sidebar>
    </div>
  </div>
</template>

<script>
import OSWordSplitGrid from "./components/grid";

export default {
  components: {
    OSWordSplitGrid,
  },

  data() {
    return {
      isLocationInfoOpened: false,
    };
  },

  watch: {
    isLocationInfoOpened: {
      handler() {
        if (this.isLocationInfoOpened) {
          document.body.style.overflow = "hidden";
        } else {
          document.body.style.overflowY = "scroll";
        }
      },
    },
  },

  computed: {
    localeMap() {
      const langId = localStorage.getItem("currentLangId");

      const localeKey =
        langId === "1252" ? "EN" : langId === "950" ? "TC" : "SC";

      return {
        EN: {
          uatWarning:
            "Below is PRODUCTION data, please conduct your test carefully.",
          reminder_1:
            "The newly created records, updated records and deleted records on that day will be activated and synchronized to CPS+ eMarketPlace at 03:00 (UTC+8) next day.",
          reminder_2:
            "The maximum amount of the word split records can be created in Open Search is 1000.",
          pageDesc: "Restrict EMP Search Function Word Split Result",
          imageSrc:
            "https://cdn.adsalecdn.com/EMP/Backend/Images/1252/Search_Location_EN.png",
          // funcReminder: "Request takes time, please wait 5-10 seconds and refresh the list after the update.",
        },
        TC: {
          uatWarning: "以下為 PRODUCTION 環境資料，請務必小心測試。",
          reminder_1:
            "當天新建的紀錄、更新的紀錄和刪除的紀錄將會於下一天的 03:00 (UTC+8) 被啟用並同步到 CPS+ 在線供需對接平台。",
          reminder_2: "最多可於公開搜尋建立的分詞紀錄數為 1000。",
          pageDesc: "限制 EMP 搜尋功能的分詞結果",
          imageSrc:
            "https://cdn.adsalecdn.com/EMP/Backend/Images/950/Search_Location_TC.png",
          // funcReminder: "請求需時，請在更新後耐心等待 5-10 秒，再刷新列表。",
        },
        SC: {
          uatWarning: "以下为 PRODUCTION 环境资料，请务必小心测试。",
          reminder_1:
            "当天新建的记录、更新的记录和删除的记录将会在下一天的 03:00 (UTC+8) 被启用并同步到 CPS+ 在线供需对接平台。",
          reminder_2: "最多可於开放搜索建立的分词记录数为 1000。",
          pageDesc: "限制 EMP 搜索功能的分词结果",
          imageSrc:
            "https://cdn.adsalecdn.com/EMP/Backend/Images/936/Search_Location_SC.png",
          // funcReminder: "请求需时，请在更新后耐心等待 5-10 秒，再刷新列表。",
        },
      }[localeKey];
    },

    reminderMessages() {
      const localeMap = this.localeMap;
      const prefix = "reminder_";

      return Object.keys(localeMap)
        .filter((key) => key.includes(prefix))
        .map((_, index) => {
          const num = index + 1;
          const localeMapKey = prefix + num.toString();
          return localeMap[localeMapKey];
        });
    },

    isUatEnv() {
      var envName = process.env.VUE_APP_EMP_ENV_NAME;

      if (envName.toLowerCase() == 'uat') {
        return true;
      }

      return false;
    },
    EnvTitle(){
      var envName = process.env.VUE_APP_EMP_ENV_NAME;

      if (envName.toLowerCase() == 'uat') {
        return "UAT Environment";
      }
      if (envName.toLowerCase() == 'ai') {
        return "CPS+AI Environment";
      }
      return "";
    },   
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  padding: 32px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 24px;
  background: var(--Surface, #fff);
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.08);
}

button.close-sidebar-btn {
  border: none;
  background-color: transparent;
  top: 26px;
  right: 20px;
}

.reminder-text {
  font-size: 14px;
  color: rgba(43, 43, 43, 0.54);
  letter-spacing: 1px;
}
</style>
